import useNetwork from '@/hooks/useNetwork';
import { ethnicityValues } from '@/pages/partners/queryUtils/ethnicities';
import { extractArrayFromQuery } from '@/utils/user/getSearchParamsFromQuery';
import { useConnect } from '@lore/query-connect';
import { genderValues }  from '@/pages/partners/queryUtils/genders';

export function getNearby(search) {
  if (!search.locationCondition) {
    return undefined;
  }

  try {
    const { radius, radiusOperator } = JSON.parse(search.locationCondition);

    if (!radius || !radiusOperator) {
      return undefined;
    }

    return {
      value: radius,
      operator: radiusOperator
    };
  } catch (error) {
    console.warn('Ignoring malformed locationCondition query param', error);
    return undefined;
  }
}

function getFilter(search, network, site) {
  const filter = {
    intent: 'partner',
    joined: search.joined?.length ? search.joined : undefined,
    siteNetwork: network?.id,
    siteId: site?.id,
    skills: search.expertiseTypes?.length ? extractArrayFromQuery(search, 'expertiseTypes') : undefined,
    ages: search.ages?.length ? extractArrayFromQuery(search, 'ages') : undefined,
    activities: search.activities?.length ? extractArrayFromQuery(search, 'activities') : undefined,
    experiences: search.experiences?.length ? extractArrayFromQuery(search, 'experiences') : undefined,
    guidances: search.guidances?.length ? extractArrayFromQuery(search, 'guidances') : undefined,
    groups: search.groups?.length ? extractArrayFromQuery(search, 'groups') : undefined,
    genders: genderValues(search),
    ethnicities: ethnicityValues(search),
    hours: search.hoursServed?.length && { value: search.hoursServed, operator: search.hoursOperator },
    contributions: search.contributionAmount?.length && { value: search.contributionAmount, operator: search.contributionsOperator },
    participation: search.participation?.length && { value: search.participation, operator: search.participationOperator },
    students: search.students?.length && { value: search.students, operator: search.studentsOperator },
    partnerEvaluations: search.evaluations?.length && { value: search.evaluations, operator: search.evaluationsOperator },
    profile: search.searchPartner?.length ? search.searchPartner : undefined,
    name: search.name?.length ? search.name : undefined,
    organization: search.organization?.length ? search.organization : undefined,
    nearby: getNearby(search),
  };
  return Object.keys(filter).length > 0 ? { filter } : {};
}

export default function useQuery(props) {
  const {
    search = {},
    pageSize = 0,
    returnCsvQuery = false
  } = props;

  const network = useNetwork();

  const query = {
    where: {
      eager: {},
      ...getFilter(search, network, props?.site),
    },
    pagination: returnCsvQuery ? undefined :{
      page: search.page || '1',
      pageSize: pageSize,
      order: search.order || 'createdAt desc',
    }
  };

  const result = useConnect('user.find', query, {
    enabled: !returnCsvQuery,
    keepPreviousData: true
  });

  if (returnCsvQuery) {
    return query;
  }

  return result;
}
